import { render, staticRenderFns } from "./Ychuan.vue?vue&type=template&id=3eb04b28&scoped=true"
import script from "./Ychuan.vue?vue&type=script&lang=js"
export * from "./Ychuan.vue?vue&type=script&lang=js"
import style0 from "./Ychuan.vue?vue&type=style&index=0&id=3eb04b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb04b28",
  null
  
)

export default component.exports